import { oc } from "@orpc/contract";
import { z } from "zod";

/**
 * Background work that failed (spec, "Na de fixes"): registering, a password reset or a new
 * confirmation link does its work after the answer (#223); when that fails it is an item in the
 * start page's work queue until an employee marks it handled.
 */

/** Which work: registering, a password reset link, a new confirmation link. */
export const BackgroundWork = z.enum(["registration", "passwordReset", "confirmationResend"]);
export type BackgroundWork = z.infer<typeof BackgroundWork>;

/** What went wrong: the mail did not go, or the work itself failed. */
export const BackgroundFailureKind = z.enum(["mailNotSent", "error"]);
export type BackgroundFailureKind = z.infer<typeof BackgroundFailureKind>;

/** One failure: oldest first in the queue. */
export const BackgroundFailure = z.object({
	id: z.string(),
	work: BackgroundWork,
	failure: BackgroundFailureKind,
	/** The address it was for, masked (`a***@e***.nl`): anyone can type any address. */
	email: z.string(),
	at: z.iso.datetime(),
});
export type BackgroundFailure = z.infer<typeof BackgroundFailure>;

export const BackgroundFailureContract = {
	/**
	 * Marks the failure handled ("Afgehandeld"), signed with the employee: it leaves the work queue.
	 * Again changes nothing. Errors: `BackgroundFailureNotFound` (404).
	 */
	resolve: oc
		.route({ method: "POST", path: "/admin/background-failures/{id}/resolve", successStatus: 204 })
		.input(z.object({ id: z.string() })),
};
